import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Loader } from "@components";
import { PRIVATE_ROUTE } from "../../route.constants";

const {
  HOME,
  DASHBOARD,
  TEMPLATE_MGNT,
  SETTINGS,
  BUSINESS_INFORMATION,
  TERMS_CONDITIONS,
  PAYMENT_METHODS,
  // DELIVERY_AREA,
  CUSTOMER_LOGIN_METHODS,
  CANCEL_REASON,
  DATA_MGNT,
  PRODUCTS,
  CATEGORIES,
  CATALOGUES,
  PRODUCT_DETAILS,
  EDIT_PRODUCT,
  EDIT_PRODUCT_OPTIONS,
  EDIT_PRICE,
  ORDERS,
  ORDER_MGNT,
  ORDER_DETAILS,
  TEMPLATE,
  STOCK_MGNT,
  STOCK_INVENTORY_REPORT,
  USER_MANAGEMENT,
  REPORTS,
  ADMIN_REPORT,
  USER_REPORT,
  INCOME_REPORT,
  ORDER_REPORT,
  ADMINS,
  BRAND,
  PAYMENT_TERMS_CONDITIONS,
  PROFILE,
  BEST_SELLING_PRODUCTS,
  // DELIVERY_AREA_TERMS,
  WELCOME_MESSAGE,
  OPT_USAGE_REPORT,
  NOTIFICATION,
  PAYMENT,
  PAYMENTAUTO,
  PAYMENTMANUAL,
  EXCHANGERATE,
  MAINTENANCE,
  RECIVINGACCOUNT,
  PAYMENTREPORT,
  PAYMENTREPORTDETAILS,
  WITHDRAWREPORTS,
  PROFIT_REPORT,
  ITEMS_PROFIT,
  ADD_PACKAGE,
  PRODUCT_OPTIONS
} = PRIVATE_ROUTE;

const routes = [
  {
    path: DASHBOARD,
    component: lazy(() => import("@components/Dashboard/Dashboard")),
    exact: true,
  },
  {
    path: `${BEST_SELLING_PRODUCTS}`,
    component: lazy(() =>
      import("@components/Dashboard/BestSellingProducts")
    ),
    exact: true,
  },
  {
    path: `${ORDER_MGNT}/${ORDERS}/:status`,
    component: lazy(() => import("@components/OrderManagement/Orders/Orders")),
    exact: true,
  },
  {
    path: `${ORDER_MGNT}/${ORDERS}/:status/${ORDER_DETAILS}/:id`,
    component: lazy(() =>
      import("@components/OrderManagement/OrderDetails/OrderDetails")
    ),
    exact: true,
  },
  {
    path: `${DATA_MGNT}/${CATEGORIES}`,
    component: lazy(() =>
      import("@components/DataManagement/Categories/Categories")
    ),
    exact: true,
  },
  {
    path: `${DATA_MGNT}/${CATALOGUES}`,
    component: lazy(() =>
      import("@components/DataManagement/Catalogues/Catalogues")
    ),
    exact: true,
  },
  {
    path: `${DATA_MGNT}/${PRODUCTS}`,
    component: lazy(() =>
      import("@components/DataManagement/Products/Products")
    ),
    exact: true,
  },
  {
    path: `${DATA_MGNT}/${STOCK_MGNT}/:stock_status`,
    component: lazy(() =>
      import("@components/DataManagement/StockManagement/StockManagement")
    ),
    exact: true,
  },
  {
    path: `${DATA_MGNT}/${STOCK_INVENTORY_REPORT}/:type`,
    component: lazy(() =>
      import(
        "@components/DataManagement/StockInventoryReport/StockInventoryReport"
      )
    ),
    exact: true,
  },
  {
    path: `${DATA_MGNT}/${USER_MANAGEMENT}`,
    component: lazy(() =>
      import("@components/DataManagement/UserManagement/UserManagement")
    ),
    exact: true,
  },
  {
    path: `${PRODUCT_DETAILS}/:id`,
    component: lazy(() =>
      import(
        "@components/DataManagement/Products/ProductDetails/ProductDetails"
      )
    ),
    exact: true,
  },
  {
    path: `${EDIT_PRODUCT}/:id`,
    component: lazy(() =>
      import("@components/DataManagement/Products/EditProduct/EditProduct")
    ),
    exact: true,
  },
  {
    path: `${EDIT_PRODUCT_OPTIONS}/:id`,
    component: lazy(() =>
      import(
        "@components/DataManagement/Products/EditProduct/EditOptions/EditOptions"
      )
    ),
    exact: true,
  },
  {
    path: `${EDIT_PRICE}/:id`,
    component: lazy(() =>
      import("@components/DataManagement/Products/EditPrice/EditPrice")
    ),
    exact: true,
  },
  {
    path: `${TEMPLATE_MGNT}/${TEMPLATE}`,
    component: lazy(() =>
      import("@components/TemplateManagement/Template/Template")
    ),
    exact: true,
  },
  {
    path: `${TEMPLATE_MGNT}/${TEMPLATE}/${BUSINESS_INFORMATION}`,
    component: lazy(() =>
      import(
        "@components/TemplateManagement/Settings/BusinessInformation/BusinessInformation"
      )
    ),
    exact: true,
  },
  {
    path: `${TEMPLATE_MGNT}/${SETTINGS}/${BUSINESS_INFORMATION}`,
    component: lazy(() =>
      import(
        "@components/TemplateManagement/Settings/BusinessInformation/BusinessInformation"
      )
    ),
    exact: true,
  },
  {
    path: `${TEMPLATE_MGNT}/${SETTINGS}/${TERMS_CONDITIONS}`,
    component: lazy(() =>
      import(
        "@components/TemplateManagement/Settings/TermsConditions/TermsConditions"
      )
    ),
    exact: true,
  },
  {
    path: `${TEMPLATE_MGNT}/${SETTINGS}/${PAYMENT_TERMS_CONDITIONS}`,
    component: lazy(() =>
      import(
        "@components/TemplateManagement/Settings/PaymentTermsConditions/PaymentTermsConditions"
      )
    ),
    exact: true,
  },
  {
    path: `${PAYMENT}/${PAYMENTMANUAL}`,
    component: lazy(() =>
      import(
        "@components/TemplateManagement/Settings/PaymentMethods/PaymentMethods"
      )
    ),
    exact: true,
  },
  // {
  //   path: `${TEMPLATE_MGNT}/${SETTINGS}/${DELIVERY_AREA}`,
  //   component: lazy(() =>
  //     import(
  //       "@components/TemplateManagement/Settings/DeliveryArea/DeliveryArea"
  //     )
  //   ),
  //   exact: true,
  // },
   {
    path: `${TEMPLATE_MGNT}/${SETTINGS}/${WELCOME_MESSAGE}`,
    component: lazy(() =>
      import(
        "@components/TemplateManagement/Settings/WelcomeMessage/WelcomeMessage"
      )
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${OPT_USAGE_REPORT}`,
    component: lazy(() =>
      import("@components/Reports/OtpUsageReport/OtpUsageReport")
    ),
    exact: true,
  },
  // {
  //   path: `${TEMPLATE_MGNT}/${SETTINGS}/${DELIVERY_AREA_TERMS}`,
  //   component: lazy(() =>
  //     import(
  //       "@components/TemplateManagement/Settings/DeliveryArea/DeliveryTerms"
  //     )
  //   ),
  //   exact: true,
  // },
  {
    path: `${TEMPLATE_MGNT}/${SETTINGS}/${CUSTOMER_LOGIN_METHODS}`,
    component: lazy(() =>
      import(
        "@components/TemplateManagement/Settings/CustomerLoginMethods/CustomerLoginMethods"
      )
    ),
    exact: true,
  },
  {
    path: `${TEMPLATE_MGNT}/${SETTINGS}/${CANCEL_REASON}`,
    component: lazy(() =>
      import(
        "@components/TemplateManagement/Settings/CancelReason/CancelReason"
      )
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${ADMIN_REPORT}/:role`,
    component: lazy(() =>
      import("@components/Reports/AdminReport/AdminReport")
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${USER_REPORT}`,
    component: lazy(() => import("@components/Reports/UserReport/UserReport")),
    exact: true,
  },
  {
    path: `${REPORTS}/${INCOME_REPORT}/:period`,
    component: lazy(() =>
      import("@components/Reports/IncomeReport/IncomeReport")
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${ORDER_REPORT}/:period`,
    component: lazy(() =>
      import("@components/Reports/OrderReport/OrderReport")
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${PROFIT_REPORT}/:period`,
    component: lazy(() =>
      import("@components/Reports/ProfitReport/ProfitReport")
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${PROFIT_REPORT}/:period/details/:id`,
    component: lazy(() =>
      import("@components/Reports/ProfitReport/ProfitReportDetails")
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${ITEMS_PROFIT}`,
    component: lazy(() =>
      import("@components/Reports/ItemsProfitReport/ItemsProfit")
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${ITEMS_PROFIT}/details/:id/:variantId?`,
    component: lazy(() =>
      import("@components/Reports/ItemsProfitReport/ItemsProfitDetails")
    ),
    exact: true,
  },
  {
    path: ADMINS,
    component: lazy(() => import("@components/AdminManagement/Admins/Admins")),
    exact: true,
  },
  {
    path: `${DATA_MGNT}/${BRAND}`,
    component: lazy(() => import("@components/DataManagement/Brand/Brand")),
    exact: true,
  },
   {
    path: `${DATA_MGNT}/${PRODUCT_OPTIONS}`,
    component: lazy(() => import("@components/DataManagement/Products/productOptions")),
    exact: true,
  },
  {
    path: `${PROFILE}`,
    component: lazy(() => import("@components/Profile/Profile")),
    exact: true,
  },
  {
    path: `${NOTIFICATION}`,
    component: lazy(() => import("@components/TemplateManagement/Settings/Notifications/Notification")),
    exact: true,
  },
  {
    path: `${NOTIFICATION}/details/:id`,
    component: lazy(() => import("@components/TemplateManagement/Settings/Notifications/NotiDetails")),
    exact: true,
  },
  {
    path: `${PAYMENT}/${PAYMENTAUTO}`,
    component: lazy(() =>
      import("@components/StorePayment/AutoPayment/AutoPaymentTable")
    ),
    exact: true,
  },
  {
    path: `${PAYMENT}/${PAYMENTAUTO}/paymentDetails`,
    component: lazy(() =>
      import("@components/StorePayment/AutoPayment/ServiceUsageHistory")
    ),
    exact: true,
  },
  {
    path: `${PAYMENT}/${EXCHANGERATE}`,
    component: lazy(() =>
      import("@components/StorePayment/ExchangeRate")
    ),
    exact: true,
  },
  {
    path: `${PAYMENT}/${EXCHANGERATE}/history/:id`,
    component: lazy(() =>
      import("@components/StorePayment/ExchangeRate/ExchangeRateHistory")
    ),
    exact: true,
  },
  {
    path: `${PAYMENT}/${MAINTENANCE}`,
    component: lazy(() =>
      import("@components/StorePayment/Maintenance/PaymentMaintenance")
    ),
    exact: true,
  },
  {
    path: `${PAYMENT}/${RECIVINGACCOUNT}`,
    component: lazy(() =>
      import("@components/StorePayment/RecivingAccount/RecivingAccountTable")
    ),
    exact: true,
  },
   {
    path: `${REPORTS}/${PAYMENTREPORT}`,
    component: lazy(() =>
      import("@components/Reports/PaymentReport/PaymentReport")
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${PAYMENTREPORT}/${PAYMENTREPORTDETAILS}/:paymentType/:dateType/:date`,
    component: lazy(() =>
      import("@components/Reports/PaymentReport/PaymentReportDetails")
    ),
    exact: true,
  },
  {
    path: `${REPORTS}/${WITHDRAWREPORTS}`,
    component: lazy(() =>
      import("@components/Reports/WithdrawReport/WithdrawReportTable")
    ),
    exact: true,
  },
   {
    path: `${REPORTS}/${WITHDRAWREPORTS}/:id`,
    component: lazy(() =>
      import("@components/Reports/WithdrawReport/WithdrawReportDetails")
    ),
    exact: true,
  },
  {
    path: `${DATA_MGNT}/${ADD_PACKAGE}`,
    component: lazy(() =>
      import("@components/DataManagement/AdditionalPackage/AdditionalPackageList")
    ),
    exact: true,
  },
  {
    path: `${DATA_MGNT}/${ADD_PACKAGE}/:id/:packageName`,
    component: lazy(() =>
      import("@components/DataManagement/AdditionalPackage/AdditionalPackageDetails")
    ),
    exact: true,
  },
   {
    path: `${ORDER_MGNT}/${ORDERS}/REFUND_ORDER`,
    component: lazy(() => import("@components/OrderManagement/Orders/RefundOrder")),
    exact: true,
  },
  {
    path: `${EDIT_PRODUCT}/:id/first-layer`,
    component: lazy(() =>
      import("@components/DataManagement/Products/SortVariant/FirstSortVariant")
    ),
    exact: true,
  },
  {
    path: `${EDIT_PRODUCT}/:id/second-layer`,
    component: lazy(() =>
      import("@components/DataManagement/Products/SortVariant/SecondSortVariant")
    ),
    exact: true,
  },
];

const HomeRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {routes.map((route, idx) => (
          <Route
            key={idx}
            exact={route.exact}
            path={`${route.path}/*`}
            element={<route.component />}
          />
        ))}
        <Route
          exact
          path="*"
          element={<Navigate to={`/${HOME}/${DASHBOARD}`} />}
        />
      </Routes>
    </Suspense>
  );
};

export default HomeRoutes;
